import React from 'react';
import MultiSelect from '../MultiSelect';
import { useDriverDispatcherOptions } from '../../hooks/useDispatcherOptions';

interface DriverDispatcherFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
  className?: string;
}

/**
 * Driver Dispatcher filter component with built-in data fetching
 * Wraps MultiSelect with standard dispatcher filter configuration
 */
const DriverDispatcherFilter: React.FC<DriverDispatcherFilterProps> = ({
  value,
  onChange,
  className = 'min-w-[160px]',
}) => {
  const { options, loading } = useDriverDispatcherOptions();

  return (
    <MultiSelect
      options={options}
      value={value}
      onChange={onChange}
      placeholder={loading ? 'Loading...' : 'Driver Dispatcher'}
      showClearOption={true}
      clearOptionLabel="All Driver Dispatchers"
      enableSearch={true}
      searchPlaceholder="Search driver dispatchers..."
      size="sm"
      className={className}
      disabled={loading}
      preserveOrder={true}
    />
  );
};

export default DriverDispatcherFilter;
